import { render, staticRenderFns } from "./coach-view-toolbar.vue?vue&type=template&id=0c5337a7&"
import script from "./coach-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./coach-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports